import { render, staticRenderFns } from "./shanxiTrainingSupervisionFive.vue?vue&type=template&id=46b8e986"
import script from "./shanxiTrainingSupervisionFive.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingSupervisionFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports